/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog-content[_ngcontent-%COMP%]{min-width:650px;min-height:250px}.app-dialog-body-text[_ngcontent-%COMP%]{padding-top:10px;padding-left:20px}.error-container[_ngcontent-%COMP%]{color:#c11818;padding:10px}"];
export { styles as styles };
